"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = require("prop-types");
var _Static = require("./Static.styled");
var StaticModal = exports.StaticModal = function StaticModal(_ref) {
  var isOpen = _ref.isOpen,
    title = _ref.title,
    buttonText = _ref.buttonText,
    onButtonClick = _ref.onButtonClick,
    children = _ref.children;
  return _react["default"].createElement(_reactstrap.Modal, {
    isOpen: isOpen,
    backdrop: "static"
  }, _react["default"].createElement(_Static.StyledModalHeader, null, title), _react["default"].createElement(_reactstrap.ModalBody, null, children), _react["default"].createElement(_Static.StyledModalFooter, null, _react["default"].createElement(_Static.StyledButton, {
    onClick: onButtonClick
  }, buttonText)));
};
StaticModal.propTypes = {
  title: _propTypes.PropTypes.string.isRequired,
  isOpen: _propTypes.PropTypes.bool.isRequired,
  buttonText: _propTypes.PropTypes.string.isRequired,
  onButtonClick: _propTypes.PropTypes.func.isRequired
};